// src/components/Step3.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import ProgressMessage from './ProgressMessage';
import '../css/Step4.css';

const BulkCSVExport = () => {
  const [statusMessage, setStatusMessage] = useState('대기중...');
  const [isExtracting, setIsExtracting] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [animatedText, setAnimatedText] = useState(''); // State for animated text

  const fullText = 'DB DATA => CSV FILE'; // Full text to animate

  // Effect to animate the text
  useEffect(() => {
    if (isExtracting) {
      let currentIndex = 0;

      // Timer to animate text
      const timer = setInterval(() => {
        setAnimatedText(fullText.slice(0, currentIndex + 1));
        currentIndex++;

        if (currentIndex === fullText.length) {
          currentIndex = 0; // Restart animation
        }
      }, 150); // Adjust speed here

      return () => clearInterval(timer); // Clean up on unmount or stop
    } else {
      setAnimatedText(fullText); // Reset text when not extracting
    }
  }, [isExtracting]);

  useEffect(()=> {
    const script = document.createElement('script');
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/encoding-japanese/2.0.0/encoding.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  },[])
  const handleBack = () => {
    // Back button logic here
  };
  
  
  const downloadCSV = (data, fileName) => {
    // Blob 생성
    const blob = new Blob([data], { type: 'text/csv;charset=shift_jis;' });
    
    // 다운로드 링크 생성 및 클릭
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    
    // URL 해제 및 링크 제거
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };
  
  // 파일 분할 및 다운로드 함수
  const splitAndDownloadCSV = async (data, baseFileName, maxFileSizeBytes) => {
    let offset = 0;
    let partCounter = 1;
    let header = null;
    const newlineByte = '\n'.charCodeAt(0); // 줄바꿈 문자의 ASCII 값
  
    while (offset < data.length) {
      let end = offset + maxFileSizeBytes;
  
      // 줄 단위로 파일 분할을 위해 \n 찾기 (뒤에서부터)
      while (end < data.length && data[end] !== newlineByte) {
        end--;
      }
      
      if (end === offset) {
        // 만약 \n을 찾지 못했다면 (줄바꿈이 없는 경우), 그냥 maxFileSizeBytes 만큼 자르기
        end = Math.min(offset + maxFileSizeBytes, data.length);
      }
  
      const chunk = data.slice(offset, end + 1); // \n 포함하여 자름
  
      if (partCounter === 1) {
        // 첫 번째 청크에서 헤더를 추출
        for (let i = 0; i < chunk.length; i++) {
          if (chunk[i] === newlineByte) {
            header = chunk.slice(0, i + 1);  // 첫 번째 줄(헤더) + \n 포함
            break;
          }
        }
        
        // 첫 번째 파일을 다운로드
        const fileName = `${baseFileName}_part_${partCounter}.csv`;
        downloadCSV(chunk, fileName);
      } else if (header) {
        // 두 번째 분할부터는 첫 번째 파일의 헤더를 추가
        let dataStartIndex = 0;
  
        // chunk가 빈 줄로 시작하지 않도록 처리
        if (chunk[0] === newlineByte) {
          dataStartIndex = 1;  // 빈 줄을 건너뜀
        }
  
        // 첫 번째 파일에서 가져온 헤더를 추가
        const chunkWithHeader = new Uint8Array(header.length + chunk.slice(dataStartIndex).length);
  
        chunkWithHeader.set(header, 0);  // 첫 줄에 헤더 추가
        chunkWithHeader.set(chunk.slice(dataStartIndex), header.length);  // 데이터 추가
  
        const fileName = `${baseFileName}_part_${partCounter}.csv`;
        downloadCSV(chunkWithHeader, fileName);
      } else {
        // 만약 헤더가 없으면 그대로 파일을 다운로드 (예외 처리)
        const fileName = `${baseFileName}_part_${partCounter}.csv`;
        downloadCSV(chunk, fileName);
      }
  
      // 다음 청크로 이동
      offset = end + 1;
      partCounter++;
  
      // 다운로드 후 잠시 대기하여 UI가 업데이트 될 수 있도록 함
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  };
  
  const handleStartExtract = () => {
    setIsExtracting(true);
    setStatusMessage('Products DB를 CSV로 중...');

    axios.post('http://localhost:5000/export-db-to-csv/extract-db-products')
      .then(response => {
        setStatusMessage('Products DB를 CSV로 변환 완료.');
        console.log(JSON.stringify(response));
        if (response.data.file) {
          // Convert the base64 encoded file back to binary data
          const binaryData = new Uint8Array(response.data.file.data);
          downloadCSV(binaryData, 'output_product.csv');
				}
        setTimeout(() => {
          convertOptionsTable();
        }, 500)
      })
      .catch(error => {
        console.error('Error during conversion:', error);
        setStatusMessage('DB를 CSV로 변환 중 오류가 발생했습니다.');
        setIsExtracting(false);
      });
  };

  const convertOptionsTable = () => {
    setIsExtracting(true);
    setStatusMessage('Options DB를 CSV로 변환 중...');
  
    axios.post('http://localhost:5000/export-db-to-csv/extract-db-options')
      .then(response => {
        setStatusMessage('Options DB를 CSV로 변환 완료.');
        console.log(JSON.stringify(response));
        
        if (response.data.file) {
          // Convert the base64 encoded file back to binary data
          const binaryData = new Uint8Array(response.data.file.data);
          
          // 파일 크기 체크 (15MB = 15 * 1024 * 1024 바이트) 20mb로하니까 딱 20mb 안나오고 20.3 mb 이렇게 나와서 걍 넉넉하게 15mb로 자름
          const maxFileSizeBytes = 0.5 * 1024 * 1024;
          
          if (binaryData.length > maxFileSizeBytes) {
            // 파일 크기가 0.5mb 이상일 때 분할 다운로드
            splitAndDownloadCSV(binaryData, 'output_options.csv', maxFileSizeBytes);
          } else {
            // 20MB 이하일 경우 그대로 다운로드
            downloadCSV(binaryData, 'output_options.csv');
          }
        }
  
        setTimeout(() => {
          convertMulitiImagesTable();
        }, 500);
      })
      .catch(error => {
        console.error('Error during conversion:', error);
        setStatusMessage('DB를 CSV로 변환 중 오류가 발생했습니다.');
        setIsExtracting(false);
      });
  };

  const convertMulitiImagesTable = () => {
		setIsExtracting(true);
    setStatusMessage('MultiImages DB를 CSV로 중...');

    axios.post('http://localhost:5000/export-db-to-csv/extract-db-multiImages')
      .then(response => {
        setStatusMessage('MultiImages DB를 CSV로 변환 완료.');
        console.log(JSON.stringify(response));

        if (response.data.file) {
          // Convert the base64 encoded file back to binary data
          const binaryData = new Uint8Array(response.data.file.data);
          
          // 파일 크기 체크 (15MB = 15 * 1024 * 1024 바이트) 20mb로하니까 딱 20mb 안나오고 20.3 mb 이렇게 나와서 걍 넉넉하게 15mb로 자름
          const maxFileSizeBytes = 0.5 * 1024 * 1024;
          
          if (binaryData.length > maxFileSizeBytes) {
            // 파일 크기가 0.5mb 이상일 때 분할 다운로드
            splitAndDownloadCSV(binaryData, 'output_multiImages.csv', maxFileSizeBytes);
          } else {
            // 20MB 이하일 경우 그대로 다운로드
            downloadCSV(binaryData, 'output_multiImages.csv');
          }
        }
        setTimeout(() => {
          setIsFinished(true);
					setIsExtracting(false);
        }, 500)
      })
      .catch(error => {
        console.error('Error during conversion:', error);
        setStatusMessage('DB를 CSV로 변환 중 오류가 발생했습니다.');
        setIsExtracting(false);
      });
  }

  

  return (
    <motion.div
      className="step-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h2>Extract Product DB to CSV</h2>
      {/* Animated Text */}
      <p className={`animated-text ${isExtracting ? 'extracting' : ''}`}>
        {animatedText}
      </p>
      <div className="conversion-container">
        <button
          onClick={handleBack}
          className='convert-button'
          disabled={isExtracting}
        >
          Back
        </button>
        <button
          onClick={handleStartExtract}
          className="convert-button"
          disabled={isExtracting}
        >
          Extract
        </button>
        <ProgressMessage message={statusMessage} />
        {isFinished && <Link to="/step4" className="next-button">Next</Link>}
      </div>
    </motion.div>
  );
};

export default BulkCSVExport;
